import singlePost from './community/singlePost/reducer';
import communityHome from './community/communityHome/reducer';
import editProfile from './user/editProfile/reducer';
import articleList from './articles/articleList/reducer';
import article from './articles/articleReducer';
import editorial from './tags/editorial/reducer';
import tags from './tags/shared/reducer';
import programModule from './programs/module/reducer';
import programOverview from './programs/overview/reducer';
import home from './home/reducer';
import search from './search/reducer';
import communityPosts from './community/communityPosts/reducer';
import local from './local/reducer';

const reducers = {
  singlePost,
  communityHome,
  editProfile,
  articleList,
  article,
  editorial,
  tags,
  programModule,
  programOverview,
  home,
  search,
  communityPosts,
  local,
};

export default reducers;



// WEBPACK FOOTER //
// ./src/modules/reducers.js